export class MissingSupabaseConfigError extends Error {
  constructor() {
    super(
      "A Supabase kapcsolat nincs beállítva. Add meg a NEXT_PUBLIC_SUPABASE_URL és NEXT_PUBLIC_SUPABASE_ANON_KEY változókat.",
    );
    this.name = "MissingSupabaseConfigError";
  }
}

export function getSupabaseEnv() {
  const url = process.env.NEXT_PUBLIC_SUPABASE_URL;
  const anonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

  if (!url || !anonKey) {
    throw new MissingSupabaseConfigError();
  }

  return { url, anonKey };
}
